import { Down } from '@linktivity/link-icons';
import type { BookingStepProps } from './BookingStep.types';
import styles from './bookingStep.module.css';

/**
 * One step of the column layout — date, plan, people — open by default and
 * foldable by its title.
 *
 * A native `<details>`: it folds before any script has loaded, and needs no
 * state of its own.
 */
const BookingStep = ({ title, children }: BookingStepProps) => (
  <details className={styles.step} open>
    <summary className={styles.summary}>
      {title}
      <Down className={styles.chevron} />
    </summary>
    <div className={styles.body}>{children}</div>
  </details>
);

export default BookingStep;
